export default __webpack_public_path__ + "static/media/8.93ced60b.svg";